import { httpManager as http } from '@/plugins/HttpManager';

export const emailValidate = async ( email: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.post( '/email/validation', {
            email: email
        }).then( res => {

            resolve( res.data.result );

        }).catch( err => {

            console.log( err );
            reject( err );

        });

    });

};

export const emailSubscribe = async ( email: string, topicKey: string ): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        http.post( `/emails/subscriptions`, {
            email: email,
            topicKey: topicKey
        }).then( res => {

            resolve( res.data.message );

        }).catch( err => {

            console.log( err );
            reject( err );

        });

    });

};
